module.exports = __webpack_public_path__ + "static/zh-Hant-70e4663bb9413f66a40371581f6e784a.png";